<template>
  <div class="AuditProgress">
    <el-dialog
      v-if="isDialogShow"
      :title="title"
      width="1000px"
      :before-close="handleClose"
      class="dialog-wrap form-module"
      :visible.sync="auditProgressShow"
      @open="handleOpen"
    >
      <el-table class="table_wrap1" :data="flowList">
        <el-table-column label="审核流程" prop="flowcategory"></el-table-column>
        <el-table-column label="流程编号" prop="flowname"></el-table-column>
        <el-table-column label="流程提交时间" prop="createdate"></el-table-column>
        <el-table-column label="状态" prop="result"></el-table-column>
        <el-table-column label="审核意见" prop="remark"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="btn_wrap">
              <el-button class="btn" @click="fnDetail(scope.row.flowcode, scope.row.fkvalue)" type="text" size="small">查看详细</el-button>
              <el-button
                class="btn"
                @click="fnRevokeFlow(scope.row.flowcode, scope.row.fkvalue)"
                type="text"
                v-if="scope.row.flowresult == 0 && scope.row.flowcode != '2937'"
                size="small"
                >撤回流程</el-button
              >
              <!-- <el-button
                class="btn"
                @click="fnEdit(scope.row.flowcode, scope.row.fkvalue)"
                type="text"
                v-if="(scope.row.flowresult == 2 || scope.row.flowresult == 3) && scope.row.flowcode != '2937'"
                size="small"
                >编辑</el-button
              > -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    flowcodes: {
      type: String,
      default: ''
    },
    fkvalue: {
      type: String,
      default: ''
    },
    auditProgressShow: {
      type: Boolean,
      default: false
    },
    isDialogShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      search: '',
      tableData: [],
      tableData1: [],
      top: 0,
      tableHeight: null,
      title: '审核进度',
      flowList: []
    }
  },
  mounted() {
    if (!this.isDialogShow) {
      this.$nextTick(() => {
        this.getElementToPageTop(this.$refs.fixedTable.$el)
        this.tableHeight = document.documentElement.clientHeight - this.top - 69 + 'px'
      })
    }
    if (!this.isEmpty(this.flowcodes) || !this.isEmpty(this.fkvalue)) {
      this.getData()
    }
  },
  methods: {
    getElementToPageTop(el) {
      if (el.parentElement) {
        this.getElementToPageTop(el.parentElement)
        if (el.offsetTop) {
          this.top = el.offsetTop
        }
      }
    },
    handleClose() {
      this.active = 1
      this.title = '审核进度'
      this.title1 = ''
      this.status = 'success'
      this.title2 = '待甲方确认'
      this.$emit('update:auditProgressShow', false)
    },

    getData() {
      let config = {
        params: {
          flowCodes: this.flowcodes,
          fkValues: this.fkvalue
        }
      }
      this.getRequest('/Common/GetFlowInstanceList', config).then((res) => {
        if (res.data.errcode == 0) {
          this.flowList = res.data.flow
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    handleOpen() {
      // alert(this.flowcodes, this.fkvalue);
      if (!this.isEmpty(this.flowcodes) || !this.isEmpty(this.fkvalue)) {
        this.getData()
      }
    },
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    fnEdit(flowcode, fkvalue) {
      if (flowcode == '2921') {
        let routerData = this.$router.resolve({
          name: 'EditContract',
          query: {
            contractId: fkvalue
          }
        })
        window.open(routerData.href, '_blank')
      } else if (flowcode == '2936' || flowcode == '2937') {
        let routerData = this.$router.resolve({
          name: 'ArrivalConfirm',
          query: {
            contractId: this.fkvalue
          }
        })
        window.open(routerData.href, '_blank')
      } else if (flowcode == '2943') {
        let routerData = this.$router.resolve({
          name: 'InvoiceUpload',
          query: {
            contractId: this.fkvalue,
            invoiceId: fkvalue,
            isDetail: false
          }
        })
        window.open(routerData.href, '_blank')
      }
    },
    fnDetail(flowcode, fkvalue) {
      if (flowcode == '2921') {
        let routerData = this.$router.resolve({
          name: 'ContractDetail',
          query: {
            contractId: fkvalue
          }
        })
        window.open(routerData.href, '_blank')
      } else if (flowcode == '2936' || flowcode == '2937') {
        let routerData = this.$router.resolve({
          name: 'ArrivalConfirm',
          query: {
            contractId: this.fkvalue
          }
        })
        window.open(routerData.href, '_blank')
      } else if (flowcode == '2943') {
        let routerData = this.$router.resolve({
          name: 'InvoiceUpload',
          query: {
            contractId: this.fkvalue,
            invoiceId: fkvalue,
            isDetail: true
          }
        })
        window.open(routerData.href, '_blank')
      } else if (flowcode == '2964') {
        let routerData = this.$router.resolve({
          name: 'RetentionPaymentEdit',
          query: {
            contractId: this.fkvalue,
            autoId: fkvalue,
            isDetail: true
          }
        })
        window.open(routerData.href, '_blank')
      }
    },
    fnRevokeFlow(flowcode, fkvalue) {
      this.$confirm('是否确认撤销流程', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //确认撤标
        this.postRequest('/Common/RevokeFlow', {
          flowCode: flowcode,
          fkValue: fkvalue
        })
          .then((res) => {
            var data = res.data
            if (data.errcode == 0) {
              this.$message.success('撤销成功')
              this.handleClose()
            } else {
              this.$message.error(data.errmsg)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.AuditProgress {
  .statistics_table {
    width: 96%;
    margin: 5px auto;

    td {
      text-align: center;
    }
  }

  ::v-deep .el-table {
    tr {
      background: #f0f5f9;
    }

    .el-table__header-wrapper {
      background: #c6daeb;
    }
  }

  ::v-deep .el-dialog__body {
    // max-height: 500px;
    // overflow-y: auto;
    padding: 0 !important;

    .el-table__body,
    .el-table__header-wrapper {
      width: 1000px !important;
    }
  }

  .total {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    font-size: 13px;
    background: #a1cbf1;
  }

  .header-wrap .header-right .search-input label {
    font-size: 13px;
  }
}
</style>